/* Muse & Maker - price groups (4 Oct 2026).
   ONE rule for the whole site: a fabric's price per metre, read from the Muse & Maker Database
   (options tab), becomes a group of 1 to 4, shown as four pound signs with the ones that apply in ink.
   Nothing is stored per fabric: change a price in the database and the group follows.
   The link between a library fabric and its database row is the sample variant id
   (database column B = the card's data-vid).
   On a fabric card the marks stay hidden until the card is hovered (on a phone: tapped once, the
   theme's first-tap-reveals rule, class mm-touched), like the description and the sample button. Inside the configurator they are always shown: wrap the cards in an
   element with the class mm-pg-always.
   On a fabric's own page the line 'Price category' is written by this file, after Composition;
   it is not typed into the product description.
   To move a boundary, change CUTS. To change the symbol, change SYMBOL. */
(function () {
  'use strict';
  if (window.MMPriceGroup) return;
  var SYMBOL = '£';
  var CUTS = [70, 82, 135]; /* price per metre: below 70 = 1, below 82 = 2, below 135 = 3, otherwise 4 */
  var SRC = 'https://docs.google.com/spreadsheets/d/1A5olGYBGgrnirCthmR1R5F_sdgsE67utbnpbJbWbzDA/gviz/tq?tqx=out:csv&gid=0&headers=1&tq=' + encodeURIComponent('select B,D,K');
  var KEY = 'mm_price_groups_v1';
  var FRESH = 5 * 60 * 1000, STALE = 24 * 60 * 60 * 1000;

  function group(price) {
    price = Number(price);
    if (!(price > 0)) return 0;
    for (var i = 0; i < CUTS.length; i++) if (price < CUTS[i]) return i + 1;
    return CUTS.length + 1;
  }
  function parse(csv) {
    var map = {}, lines = String(csv).split(/\r?\n/);
    for (var i = 1; i < lines.length; i++) {
      var c = lines[i].replace(/"/g, '').split(',');
      var vid = (c[0] || '').trim(), price = parseFloat(c[1]), deleted = (c[2] || '').trim() === '1';
      if (vid && !deleted && price > 0) map[vid] = price;
    }
    return map;
  }
  function readCache() {
    try { var e = JSON.parse(localStorage.getItem(KEY) || 'null'); return e && e.t && e.map ? e : null; } catch (x) { return null; }
  }
  function writeCache(map) {
    try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), map: map })); } catch (x) {}
  }
  function load() {
    var cached = readCache();
    if (cached && Date.now() - cached.t < FRESH) return Promise.resolve(cached.map);
    return fetch(SRC).then(function (r) {
      if (!r.ok) throw new Error('price groups: ' + r.status);
      return r.text();
    }).then(function (t) {
      if (/^\s*</.test(t)) throw new Error('price groups: not a csv');
      var map = parse(t);
      if (!Object.keys(map).length) throw new Error('price groups: empty');
      writeCache(map);
      return map;
    }).catch(function (err) {
      if (cached && Date.now() - cached.t < STALE) return cached.map;
      try { console.warn('[mm-price-group]', err && err.message); } catch (x) {}
      return {};
    });
  }
  function mark(g) {
    var s = document.createElement('span');
    s.className = 'mm-pg';
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', 'Price group ' + g + ' of ' + (CUTS.length + 1));
    s.setAttribute('data-pg', String(g));
    var on = document.createElement('span'); on.textContent = new Array(g + 1).join(SYMBOL);
    var off = document.createElement('i'); off.setAttribute('aria-hidden', 'true'); off.textContent = new Array(CUTS.length + 2 - g).join(SYMBOL);
    s.appendChild(on); s.appendChild(off);
    return s;
  }
  function css() {
    if (document.getElementById('mm-pg-css')) return;
    var st = document.createElement('style'); st.id = 'mm-pg-css';
    st.textContent =
      '.mm-pg{font-family:"GT Alpina Typewriter",ui-monospace,monospace;font-size:12px;line-height:1.4;letter-spacing:.22em;color:#2C2926;white-space:nowrap}' +
      '.mm-pg i{font-style:normal;color:#CFC6B6}' +
      '.mm-fabcard .mm-pg{display:block;text-align:center;margin-top:4px;padding-left:.22em;opacity:0;transition:opacity .3s .05s}' +
      '.mm-fabcard:hover .mm-pg,.mmf-cell:hover .mm-pg,.mml-cell:hover .mm-pg,.mm-fabcard:focus-within .mm-pg{opacity:1}' +
      'html.mm-touch .mm-fabcard .mm-pg{opacity:0}' +
      'html.mm-touch .mm-fabcard.mm-touched .mm-pg,html .mm-pg-always .mm-fabcard .mm-pg.mm-pg{opacity:1}' +
      '.product__description .mm-pg{font-size:14px;letter-spacing:.18em}' +
      '.mm-pg-wait em{visibility:hidden}';
    document.head.appendChild(st);
  }
  function cards(map) {
    var list = document.querySelectorAll('.mm-fabcard');
    for (var i = 0; i < list.length; i++) {
      var card = list[i];
      if (card.getAttribute('data-pg')) continue;
      var btn = card.querySelector('[data-vid]');
      var g = btn ? group(map[btn.getAttribute('data-vid')]) : 0;
      card.setAttribute('data-pg', String(g));
      if (card.parentElement && /\bmmf-cell\b/.test(card.parentElement.className)) card.parentElement.setAttribute('data-pg', String(g));
      if (!g) continue;
      var meta = card.querySelector('.mm-fabmeta');
      if (meta && meta.parentNode) meta.parentNode.insertBefore(mark(g), meta.nextSibling);
    }
  }
  function pdpLine() {
    var ps = document.querySelectorAll('.product__description p');
    for (var i = 0; i < ps.length; i++) {
      var st = ps[i].querySelector('strong');
      if (st && /^\s*price category\s*$/i.test(st.textContent)) return ps[i];
    }
    return null;
  }
  function pdp(map) {
    var box = document.querySelector('.product__description');
    if (!box || box.getAttribute('data-pg')) return;
    var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var g = idEl ? group(map[idEl.value]) : 0;
    var p = pdpLine();
    box.setAttribute('data-pg', String(g));
    if (p) p.classList.remove('mm-pg-wait');
    if (!g) { if (p) p.style.display = 'none'; return; }
    if (!p) {
      /* The line is not typed into the product description: it is added here, after Composition. */
      p = document.createElement('p');
      var label = document.createElement('strong'); label.textContent = 'Price category';
      p.appendChild(label);
      var after = null, ps = box.querySelectorAll('p');
      for (var i = 0; i < ps.length; i++) {
        var s0 = ps[i].querySelector('strong');
        if (s0 && /^[ \t]*composition/i.test(s0.textContent)) after = ps[i];
      }
      if (after && after.parentNode) after.parentNode.insertBefore(p, after.nextSibling); else box.appendChild(p);
    }
    var st = p.querySelector('strong');
    while (st.nextSibling) p.removeChild(st.nextSibling);
    p.appendChild(document.createTextNode(': '));
    p.appendChild(mark(g));
  }
  var ready = null;
  function run() {
    css();
    var p = pdpLine();
    if (p && !p.getAttribute('data-pg')) p.classList.add('mm-pg-wait');
    if (!ready) ready = load();
    ready.then(function (map) {
      cards(map); pdp(map);
      if (!run.watching && window.MutationObserver) {
        run.watching = true;
        var t = null;
        new MutationObserver(function () {
          if (t) return;
          t = setTimeout(function () { t = null; cards(map); pdp(map); }, 120);
        }).observe(document.body, { childList: true, subtree: true });
      }
    });
    return ready;
  }
  window.MMPriceGroup = {
    cuts: CUTS.slice(), symbol: SYMBOL, group: group, mark: mark,
    ready: function () { return ready || run(); },
    forVariant: function (vid) { return (ready || run()).then(function (m) { return group(m[String(vid)]); }); }
  };
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
